import { takeLatest, call, put } from 'redux-saga/effects'
import {
    auditAddLogAPI, auditAddLogCommentAPI, auditAssignUserAPI, auditDetailAPI,
    auditListAPI, auditUpdateLogStatusAPI, auditUpdateStatusAPI, newAuditAPI
} from '../api-requests/audit';
import {
    auditAddLogCommentRequestError, auditAddLogCommentRequestSuccess, auditAddLogRequestError,
    auditAddLogRequestSuccess, auditAssignUserRequestError, auditAssignUserRequestSuccess,
    auditDetailRequestError, auditDetailRequestSuccess, auditListRequestError, auditListRequestSuccess,
    auditUpdateLogStatusRequestError, auditUpdateLogStatusRequestSuccess, auditUpdateStatusRequestError,
    auditUpdateStatusRequestSuccess, newAuditRequestError, newAuditRequestSuccess
} from './audit.action';
import { AuditActionTypes } from './audit.types'
import { displayConsoleLog } from '../../utils/Utils'
import { decryptResponseData } from '../../utils/DataDecryptionUtils';
import { APP_CONSTANTS } from '../../utils/AppConstants';

function* handleNewAuditRequest({ payload }) {
    try {
        const response = yield call(newAuditAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(newAuditRequestSuccess(decryptedData))
            } else {
                yield put(newAuditRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: AuditActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(newAuditRequestError(error.response.data))
        }
    }
}

export function* newAuditReq() {
    yield takeLatest(AuditActionTypes.NEW_AUDIT_REQUEST, handleNewAuditRequest)
}

function* handleAuditUpdateStatusRequest({ payload }) {
    try {
        const response = yield call(auditUpdateStatusAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(auditUpdateStatusRequestSuccess(decryptedData))
            } else {
                yield put(auditUpdateStatusRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: AuditActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(auditUpdateStatusRequestError(error.response.data))
        }
    }
}

export function* auditUpdateStatusReq() {
    yield takeLatest(AuditActionTypes.AUDIT_UPDATE_STATUS_REQUEST, handleAuditUpdateStatusRequest)
}

function* handleAuditUpdateLogStatusRequest({ payload }) {
    try {
        const response = yield call(auditUpdateLogStatusAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(auditUpdateLogStatusRequestSuccess(decryptedData))
            } else {
                yield put(auditUpdateLogStatusRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: AuditActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(auditUpdateLogStatusRequestError(error.response.data))
        }
    }
}

export function* auditUpdateLogStatusReq() {
    yield takeLatest(AuditActionTypes.AUDIT_UPDATE_LOG_STATUS_REQUEST, handleAuditUpdateLogStatusRequest)
}

function* handleAuditListRequest({ payload }) {
    try {
        const response = yield call(auditListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(auditListRequestSuccess(decryptedData))
            } else {
                yield put(auditListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: AuditActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(auditListRequestError(error.response.data))
        }
    }
}

export function* auditListReq() {
    yield takeLatest(AuditActionTypes.AUDIT_LIST_REQUEST, handleAuditListRequest)
}

function* handleAuditDetailRequest({ payload }) {
    try {
        const response = yield call(auditDetailAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(auditDetailRequestSuccess(decryptedData))
            } else {
                yield put(auditDetailRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: AuditActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(auditDetailRequestError(error.response.data))
        }
    }
}

export function* auditDetailReq() {
    yield takeLatest(AuditActionTypes.AUDIT_DETAIL_REQUEST, handleAuditDetailRequest)
}

function* handleAuditAssignUserRequest({ payload }) {
    try {
        const response = yield call(auditAssignUserAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(auditAssignUserRequestSuccess(decryptedData))
            } else {
                yield put(auditAssignUserRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: AuditActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(auditAssignUserRequestError(error.response.data))
        }
    }
}

export function* auditAssignUserReq() {
    yield takeLatest(AuditActionTypes.AUDIT_ASSIGN_USER_REQUEST, handleAuditAssignUserRequest)
}

function* handleAuditAddLogRequest({ payload }) {
    try {
        const response = yield call(auditAddLogAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(auditAddLogRequestSuccess(decryptedData))
            } else {
                yield put(auditAddLogRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: AuditActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(auditAddLogRequestError(error.response.data))
        }
    }
}

export function* auditAddLogReq() {
    yield takeLatest(AuditActionTypes.AUDIT_ADD_LOG_REQUEST, handleAuditAddLogRequest)
}

function* handleAuditAddLogCommentRequest({ payload }) {
    try {
        const response = yield call(auditAddLogCommentAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(auditAddLogCommentRequestSuccess(decryptedData))
            } else {
                yield put(auditAddLogCommentRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: AuditActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(auditAddLogCommentRequestError(error.response.data))
        }
    }
}

export function* auditAddLogCommentReq() {
    yield takeLatest(AuditActionTypes.AUDIT_ADD_LOG_COMMENT_REQUEST, handleAuditAddLogCommentRequest)
}